export const SET_CLIENT_ORDER_LOADING = "SET_CLIENT_ORDER_LOADING";
export const CLEAR_CLIENT_ORDER_STORE = "CLEAR_CLIENT_ORDER_STORE";
export const SET_CLIENT_ORDER_DATA = "SET_CLIENT_ORDER_DATA";
export const SET_CLIENT_ORDER_FILTER = "SET_CLIENT_ORDER_FILTER";
export const SET_CLIENT_PRODUCTION_ORDER_DATA =
  "SET_CLIENT_PRODUCTION_ORDER_DATA";
export const SET_CLIENT_PRODUCTION_ORDER_LOADING =
  "SET_CLIENT_PRODUCTION_ORDER_LOADING";
export const SET_ACTIVE_CLIENT_ORDER = "SET_ACTIVE_CLIENT_ORDER";
